import React from "react";
import { ThemeProvider, createTheme, Theme, StyledEngineProvider } from "@mui/material/styles";
import { primaryBrightBlue, medBlue, darkGrey } from "../../constants/colors";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

// TODO: Create complete theme? https://material-ui.com/customization/palette/
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: primaryBrightBlue,
      contrastText: "#000",
    },
    secondary: {
      main: medBlue,
    },
    text: {
      primary: "#000",
      secondary: darkGrey,
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: primaryBrightBlue,
      contrastText: "#fff",
    },
    secondary: {
      main: medBlue,
    },
    background: {
      default: "#121212",
      paper: "#121212",
    },
  },
});

export const ThemeManager = ({
  theme,
  children,
}: {
  theme: Theme;
  children: React.ReactNode;
}): React.JSX.Element => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
};
